export const environment = {
  production: true,
  domain: 'https://globalmarinecity.com',
  host: 'https://api.globalmarinecity.com',
  uploadsHost: 'https://uploads.globalmarinecity.com'
};



// WEBPACK FOOTER //
// ./environments/environment.prod.ts